import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface FunnelStep {
  step: string;
  page: string;
  timestamp: number;
  completed: boolean;
}

const FUNNEL_STEPS = [
  { step: 'landing', pages: ['/', '/home'] },
  { step: 'search', pages: ['/find'] },
  { step: 'profile', pages: ['/therapist/'] },
  { step: 'booking', pages: ['/booking/'] },
  { step: 'payment', pages: ['/checkout'] },
  { step: 'confirmation', pages: ['/booking-success'] },
];

export const useFunnelAnalytics = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState<string>('');

  useEffect(() => {
    // Determine current funnel step
    const step = FUNNEL_STEPS.find(s => 
      s.pages.some(page => location.pathname.includes(page))
    );

    if (step) {
      setCurrentStep(step.step);
      
      // Track funnel step
      const funnelData = JSON.parse(localStorage.getItem('funnel_data') || '[]');
      const lastStep = funnelData[funnelData.length - 1];

      // Only add if it's a new step or different from last
      if (!lastStep || lastStep.step !== step.step) {
        funnelData.push({
          step: step.step,
          page: location.pathname,
          timestamp: Date.now(),
          completed: false,
        });

        localStorage.setItem('funnel_data', JSON.stringify(funnelData));
      }
    }
  }, [location.pathname]);

  const completeFunnelStep = (step: string) => {
    const funnelData = JSON.parse(localStorage.getItem('funnel_data') || '[]');
    const stepIndex = funnelData.findIndex((s: FunnelStep) => s.step === step);
    
    if (stepIndex !== -1) {
      funnelData[stepIndex].completed = true;
      localStorage.setItem('funnel_data', JSON.stringify(funnelData));
    }
  };

  const getDropoffRate = () => {
    const funnelData = JSON.parse(localStorage.getItem('funnel_data') || '[]');
    if (funnelData.length === 0) return 0;

    const dropoffs = funnelData.filter((s: FunnelStep) => !s.completed).length;
    return (dropoffs / funnelData.length) * 100;
  };

  return {
    currentStep,
    completeFunnelStep,
    getDropoffRate,
  };
};

export const FunnelAnalytics = () => {
  useFunnelAnalytics();
  return null;
};
